import {
  withTranslation,
} from 'react-i18next';

import RegistrationNoView from './RegistrationNoView';

const TranslatedComponent = withTranslation()(RegistrationNoView);

const Component = TranslatedComponent;

export default Component;
